/**
 * The signature element of this interface.
 *
 * A field the signed-in role may not read is shown as withheld and names the
 * permission that would reveal it, rather than disappearing. People trust a
 * system whose boundaries they can see; silent omission reads as a bug and
 * generates support tickets that say "the salary is missing".
 */
export function Redacted({ permission }: { permission: string }) {
  return (
    <span className="redacted">
      Withheld — needs <code>{permission}</code>
    </span>
  );
}
